module.exports = __webpack_public_path__ + "static/media/mid-sustainable.f7d0327a.png";